import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NetworkService } from '@core/services/network.service';

@Component({
  selector: 'app-network-modal',
  templateUrl: './network-modal.component.html',
  styleUrls: ['./network-modal.component.scss']
})
export class NetworkModalComponent implements OnInit, OnDestroy {
  isOnline = true;
  private subscription: Subscription = new Subscription();

  constructor(private readonly networkService: NetworkService, private readonly router: Router) {}

  ngOnInit() {
    this.subscription.add(
      this.networkService.isOnline$.subscribe(status => {
        this.isOnline = status;
      })
    );
  }

  ngOnDestroy() {

    this.subscription.unsubscribe();
  }
  redirectToLogin(){
  this.router.navigate(['/login']);
  }
}
